export const iconFontAwesomeMapsStreetView = (
	<i className="fa-solid fa-street-view"></i>
);
